// Battery manufacturer values offered in the UI. The backend stores `battery_manufacturer` as
// free text (there is no backend enum), so this list is the only thing constraining the value
// set — keep it aligned with the same list in onboarding_app by hand. Each value maps 1:1 to a
// hero image via `batteryLogoSrc` (lowercased value -> /assets/icons/logos/<value>.png).
// `unknown` is the empty/default state and is intentionally NOT offered as a choice — leaving
// the field blank stores nothing and reads default to "unknown".
export const batteryTypeOptions = [
    { value: '', label: 'Battery Type', hidden: true },
    { value: 'dyness', label: 'Dyness' },
    { value: 'enershare', label: 'Enershare' },
    { value: 'huawei', label: 'Huawei' },
    { value: 'pylontech', label: 'Pylontech' },
    { value: 'saj', label: 'SAJ' },
    { value: 'sigenstor', label: 'Sigenstor' },
    { value: 'other', label: 'Other' },
];

// Normalize a stored value for use as a <Select> value: treat unset/"unknown"/unrecognised
// as the empty placeholder so the dropdown shows the prompt rather than a stale value.
export const toBatteryTypeSelectValue = value => (batteryTypeOptions.some(o => o.value === value && o.value !== '') ? value : '');
